@use '~@frontrow/console/css/variables.scss';

.licenseDetailContainer {
  display: flex;
  font-size: variables.$font-size-sm;
  margin-top: variables.$std-margin-md;
  align-items: center;
}

.licenseDetail {
  margin-right: variables.$std-margin-lg;
}
